import { render, staticRenderFns } from "./GiftPurchaseForm.vue?vue&type=template&id=08a6a26b&"
import script from "./GiftPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./GiftPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports